import PageSEO from "@/components/PageSEO";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import HowItWorks from "@/components/HowItWorks";
import ChatPreview from "@/components/ChatPreview";
import Footer from "@/components/Footer";
import { useAuthModal } from "@/hooks/useAuthModal";
import DemoModal from "@/components/DemoModal";
import { useState } from "react";

const Index = () => {
  const { openSignup } = useAuthModal();
  const [demoOpen, setDemoOpen] = useState(false);

  return (
    <>
      <PageSEO
        title="KelasAI — Apprentissage personnalisé avec l'IA"
        description="KelasAI est une application éducative intelligente qui utilise une IA pour personnaliser l'apprentissage de chaque élève, du primaire à l'université."
        path="/"
      />
    <div className="min-h-dvh">
      <Navbar />
      <HeroSection />
      <HowItWorks />
      <ChatPreview />

      {/* Final CTA */}
      <section className="py-16 sm:py-24 relative overflow-hidden">
        <div className="absolute inset-0" style={{ background: "var(--gradient-hero)" }} />
        <div className="absolute inset-0 opacity-[0.08]" style={{ backgroundImage: "radial-gradient(circle, white 1.5px, transparent 1.5px)", backgroundSize: "28px 28px" }} />
        <div className="container mx-auto px-4 sm:px-6 relative z-10 text-center">
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-black text-white mb-4 leading-tight">
            Prêt à transformer ton apprentissage ? 🚀
          </h2>
          <p className="text-white/80 text-base sm:text-lg font-medium mb-8 max-w-xl mx-auto">
            Rejoins des milliers d'élèves qui utilisent KelasAI pour apprendre mieux et plus vite.
          </p>
          <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-3 sm:gap-4">
            <button onClick={openSignup} className="px-6 sm:px-8 py-4 rounded-2xl font-extrabold text-base bg-white transition-all duration-300 hover:opacity-95 hover:-translate-y-1 min-h-[48px] w-full sm:w-auto" style={{ color: "hsl(var(--primary))", boxShadow: "0 8px 32px rgba(0,0,0,0.18)" }}>
              🎓 Commencer gratuitement
            </button>
            <button onClick={() => setDemoOpen(true)} className="px-6 sm:px-8 py-4 rounded-2xl font-extrabold text-base text-white transition-all duration-300 hover:-translate-y-1 min-h-[48px] w-full sm:w-auto text-center" style={{ border: "2px solid rgba(255,255,255,0.45)", background: "rgba(255,255,255,0.12)" }}>
              ▶ Voir une démo
            </button>
          </div>
          <p className="text-white/55 text-xs sm:text-sm font-semibold mt-6">
            ✓ Gratuit pour commencer &nbsp;·&nbsp; ✓ Aucune carte requise &nbsp;·&nbsp; ✓ Annulation à tout moment
          </p>
        </div>
      </section>

      <Footer />
    </div>
    <DemoModal open={demoOpen} onClose={() => setDemoOpen(false)} />
    </>
  );
};

export default Index;
